
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withScriptjs, withGoogleMap, InfoWindow, GoogleMap, Marker, DirectionsRenderer } from "react-google-maps";
import PositionSelector from './PositionSelector';
import MapWithMarkers from './MapWithMarkers'

const googleMapURL = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAsT1m6bBdumM-VbrP6kFWbtErVLpPgXQ8&libraries=geometry,drawing,places";

class ParadigmaGoogleMap extends Component {
	constructor(props) {
		super(props);
        this.state = {
        };
    }

    static propTypes = {
        width: PropTypes.string,
        height: PropTypes.string,
        markers: PropTypes.array,
        infoWindow: PropTypes.bool,
        zoom: PropTypes.number,
        type: PropTypes.oneOf(['roadmap', 'satellite', 'hybrid', 'terrain']),

        positionSelector: PropTypes.bool,
        onChange: PropTypes.func
    }

    render() {
        const { width, height } = this.props;
        if (this.props.positionSelector) {
            return <PositionSelector
                googleMapURL={googleMapURL}
                loadingElement={<div style={{ width, height }} />}
                containerElement={<div style={{ width, height }} />}
                mapElement={<div style={{ height: `100%`, width: '100%' }} />}
                onChange={this.props.onChange}
                type={this.props.type}
            />
        } else {
            return <MapWithMarkers
                googleMapURL={googleMapURL}
                loadingElement={<div style={{ width, height }} />}
                containerElement={<div style={{ width, height }} />}
                mapElement={<div style={{ height: `100%`, width: '100%' }} />}
                markers={this.props.markers}
                zoom={this.props.zoom}
                infoWindow={this.props.infoWindow}
                type={this.props.type}
            />
        }
    }
}


module.exports = ParadigmaGoogleMap;


// WEBPACK FOOTER //
// ./src/components/ParadigmaGoogleMap/ParadigmaGoogleMap.js